import { render } from "./ModalDeliveryDetails.vue?vue&type=template&id=666a0c34&scoped=true&ts=true"
import script from "./ModalDeliveryDetails.vue?vue&type=script&lang=ts"
export * from "./ModalDeliveryDetails.vue?vue&type=script&lang=ts"

import "./ModalDeliveryDetails.vue?vue&type=style&index=0&id=666a0c34&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666a0c34"]])

export default __exports__